export default __webpack_public_path__ + "static/media/wind.5efb82fb.mp3";